import { render, staticRenderFns } from "./ImageCard.vue?vue&type=template&id=2318b218&scoped=true&"
import script from "./ImageCard.vue?vue&type=script&lang=js&"
export * from "./ImageCard.vue?vue&type=script&lang=js&"
import style0 from "./ImageCard.vue?vue&type=style&index=0&id=2318b218&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2318b218",
  null
  
)

export default component.exports